module.exports = __webpack_public_path__ + "static/image_12_thumb-dff76302693b4b8b1b2c2a490b179384.jpg";